<template>
  <div class="repairReq-main">
    <div class="repairReq-main-header">
      <p class="font-format-big text-center">即将提交您的信息，请确认以下内容正确</p>
    </div>
    <div class="repairReq-main-step5">
      <el-row class="repairReq-main-step5-row">
        <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step5-left">
          <p class="font-format-normal">产品信息</p>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step5-right">
          <div class="repairReq-main-step5-item">
            <p class="repairReq-main-step5-item-content font-format-medium">
              {{ repair.details[0].model }}
            </p>
            <el-link :underline="false" type="primary" @click="goBack(1)">修改</el-link>
          </div>
        </el-col>
      </el-row>
      <el-row class="repairReq-main-step5-row">
        <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step5-left">
          <p class="font-format-normal">产品配件</p>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step5-right">
          <div class="repairReq-main-step5-item">
            <p class="repairReq-main-step5-item-content font-format-medium">
              {{ fittingsData.map(item => item.name).join('/') }}
            </p>
            <el-link :underline="false" type="primary" @click="goBack(3)">修改</el-link>
          </div>
        </el-col>
      </el-row>
      <el-row class="repairReq-main-step5-row" v-if="repair.details[0].purchases.length">
        <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step5-left">
          <p class="font-format-normal">购买凭证</p>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step5-right">
          <div class="repairReq-main-step5-item">
            <div class="repairReq-main-step5-item-content repairReq-main-step5-attachs">
              <p
                class="font-format-medium"
                v-for="(item, index) of repair.details[0].purchases"
                :key="index"
                @click="getOssAttachsUrl(item)"
              >
                {{ item.name }}
              </p>
            </div>
            <el-link :underline="false" type="primary" @click="goBack(2)">修改</el-link>
          </div>
        </el-col>
      </el-row>
      <el-row class="repairReq-main-step5-row">
        <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step5-left">
          <p class="font-format-normal">故障信息描述</p>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step5-right">
          <div class="repairReq-main-step5-item">
            <p
              class="repairReq-main-step5-item-content font-format-medium"
              v-if="repair.details[0].desc"
            >
              {{ repair.details[0].desc }}
            </p>
            <el-link :underline="false" type="primary" @click="goBack(2)">修改</el-link>
          </div>
        </el-col>
      </el-row>
      <el-row class="repairReq-main-step5-row" v-if="repair.attachs.length">
        <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step5-left">
          <p class="font-format-normal">附件</p>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step5-right">
          <div class="repairReq-main-step5-item">
            <div class="repairReq-main-step5-item-content repairReq-main-step5-attachs">
              <p
                class="font-format-medium"
                v-for="(item, index) of repair.attachs"
                :key="index"
                @click="getOssAttachsUrl(item)"
              >
                {{ item.name }}
              </p>
            </div>
            <el-link :underline="false" type="primary" @click="goBack(2)">修改</el-link>
          </div>
        </el-col>
      </el-row>
      <el-row class="repairReq-main-step5-row">
        <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step5-left">
          <p class="font-format-normal">寄回信息（维修后寄回用）</p>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step5-right">
          <div class="repairReq-main-step5-item">
            <div class="repairReq-main-step5-item-content">
              <p class="font-format-medium">姓名：{{ repair.sendContact }}</p>
              <p class="font-format-medium">手机：{{ repair.sendPhone }}</p>
              <p class="font-format-medium" v-if="Array.isArray(repair.area) && repair.area.length">
                地区：{{ repair.area.join('/') }}
              </p>
              <p class="font-format-medium">地址：{{ repair.tmpAddress }}</p>
            </div>
            <el-link :underline="false" type="primary" @click="goBack(3)">修改</el-link>
          </div>
        </el-col>
      </el-row>
      <el-row class="repairReq-main-step5-row">
        <el-col :xl="8" :lg="8" :md="8" :sm="24" class="repairReq-main-step5-left">
          <p class="font-format-normal">寄出快递信息</p>
        </el-col>
        <el-col :xl="14" :lg="14" :md="14" :sm="24" class="repairReq-main-step5-right">
          <div class="repairReq-main-step5-item">
            <div class="repairReq-main-step5-item-content">
              <p class="font-format-medium" v-if="repair.receiveDeliveryInc">
                快递公司：{{ filterExpress(repair.receiveDeliveryInc) }}
              </p>
              <p v-else class="font-format-medium">快递公司：暂无</p>
              <p class="font-format-medium" v-if="repair.receiveDeliveryCode">
                快递单号：{{ repair.receiveDeliveryCode || '无' }}
              </p>
              <p v-else class="font-format-medium">快递单号：暂无</p>
            </div>
            <el-link :underline="false" type="primary" @click="goBack(3)">修改</el-link>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="repairReq-step5-next">
      <el-button type="text" size="default" @click="goBack()">返回上一步</el-button>
      <!-- <el-button type="warning" size="default" @click="saveData(-1)"
        >暂存</el-button
      > -->
      <el-button type="primary" size="default" @click="saveData(0)">提交</el-button>
    </div>

    <!-- 附件预览 -->
    <el-image v-show="false" ref="elImage" :preview-src-list="srcList"></el-image>
    <div class="video-component" v-if="showVideo" @click="closeVideo()">
      <div class="video-close-btn" @click.stop="closeVideo()">
        <i class="el-icon-close"></i>
      </div>
      <video controls @click.stop class="video-main">
        <source :src="videoSrc" />
      </video>
    </div>
    <!--  -->

    <el-dialog title="提示" :visible.sync="dialogVisible" width="310px">
      <span>快递公司或快递单号为空，是否先提交？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveData(-1)">是，提交</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              dialogVisible = false
              goBack(3)
            }
          "
          >否，完善信息</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    repairData: Object
  },
  data() {
    return {
      repair: {},
      dialogVisible: false,
      srcList: [],
      videoSrc: '',
      ossClient: null,
      showViewer: false,
      showVideo: false,
      fittingsData: []
    }
  },
  methods: {
    filterExpress(value) {
      const expressOpts = [
        {
          label: '京东',
          value: 'jd'
        },
        {
          label: '德邦',
          value: 'debangkuaidi'
        },
        {
          label: '顺丰',
          value: 'shunfeng'
        },
        {
          label: '极兔',
          value: 'jtexpress'
        },
        {
          label: '圆通',
          value: 'yuantong'
        },
        {
          label: '申通',
          value: 'shentong'
        },
        {
          label: '中通',
          value: 'zhongtong'
        }
      ]

      let item = expressOpts.find(ele => ele.value === value)
      return item.label || '无'
    },

    async getOssAttachsUrl(item) {
      let ossClient = await this.getOssClient()
      item.url = ossClient.signatureUrl(item.path, { expires: 3600 })
      if (['jpeg', 'jpg', 'png', 'bmp'].includes(item.format)) {
        this.srcList = [item.url]
        this.$refs.elImage.showViewer = true
      } else {
        this.videoSrc = item.url
        this.showVideo = true
      }
    },

    async getOssClient() {
      try {
        let res = await this.$http.getSts()
        let region = 'oss-cn-shenzhen'
        let bucket = 'onyx-work-order'
        let client = new OSS({
          region,
          bucket,
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          stsToken: res.data.securityToken
        })
        return client
      } catch (error) {
        throw new Error(error)
      }
    },

    closeVideo() {
      this.showVideo = false
      this.videoSrc = ''
    },

    setFittingsData() {
      if (this.repair.details[0].fittingsData) {
        this.fittingsData = JSON.parse(JSON.stringify(this.repair.details[0].fittingsData))
      }
    },

    goBack(step = null) {
      this.$emit('goBack', step)
    },
    async saveData(status) {
      try {
        if (status === 0 && (!this.repair.receiveDeliveryInc || !this.repair.receiveDeliveryCode)) {
          this.dialogVisible = true
          return
        }

        if (status === 0) {
          let str = `
                <p class=font-format-medium>1、如只是机器故障，只需寄出机器即可，数据线、保护套、电磁笔等配件无需寄回，避免回寄出现丢失，破损等意外情况，感谢您的理解。</p>
                <p class=font-format-medium>2、寄修前请自行做好数据备份，因维修导致的数据丢失，文石概不负责；</p>
                <p class=font-format-medium>3、快件打包请注意保护好屏幕，避免运输中有损坏；</p>
                <p class=font-format-medium>4、设备屏幕如有贴膜，如需换屏，屏膜将无法重贴；</p>
                <p class=font-format-medium>5、寄送前请在包裹内附上包含姓名和手机的纸条，方便查询； </p>
                <p class=font-format-medium>6、经文石检测确认后，需付费维修的设备，从文石发起付费通知七个工作日后如仍未付费确认维修，文石售后维修中心会将设备原路寄回；</p>
                <p class=font-format-medium>7、运费双方各支付一程，请勿寄到付，到付拒收；</p>
              `
          await this.$confirm(str, '寄件需知', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '同意，提交',
            cancelButtonText: '返回',
            showClose: false
          })
        }
        if (status === -1) {
          this.dialogVisible = false
        }
        this.$emit('saveData', status)
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
    repairData: {
      handler(val) {
        this.repair = val
        this.setFittingsData()
      },
      deep: true
    }
  },
  created() {
    this.repair = this.repairData
    this.setFittingsData()
  }
}
</script>

<style lang="scss">
.repairReq-main {
  .video-component {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    > .video-close-btn {
      position: absolute;
      top: 40px;
      right: 40px;
      width: 40px;
      height: 40px;
      font-size: 24px;
      color: #fff;
      background-color: #606266;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      opacity: 0.8;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
  .repairReq-main-header {
    text-align: center;
    border-bottom: 1px dashed #eee;
    padding: 30px 0;
  }
  .repairReq-main-step5 {
    /* border-bottom: 1px solid #eee; */
    .repairReq-main-step5-row + .repairReq-main-step5-row {
      border-top: 1px dashed #eee;
    }
    .repairReq-main-step5-row {
      padding: 30px 0;
      .repairReq-main-step5-left {
        margin-right: 60px;
        > p + p {
          margin-top: 10px;
        }
      }
      .repairReq-main-step5-right {
        .repairReq-main-step5-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .repairReq-main-step5-item-content {
            flex: 1;
            margin-right: 20px;
            overflow: hidden;
            > p + p {
              margin-top: 10px;
            }
          }
          .repairReq-main-step5-attachs {
            > p {
              cursor: pointer;
              &:hover {
                background: #f1f1f1;
              }
            }
          }
        }
      }
    }
  }

  .repairReq-step5-next {
    padding-top: 30px;
    border-top: 1px solid #eee;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    > .el-button:nth-child(3) {
      padding: 12px 40px;
    }
    > .el-button + .el-button {
      margin-left: 0;
    }
  }
}

@media (max-width: 1000px) {
  .repairReq-main-step5-right {
    margin-top: 20px;
    .repairReq-sn-input {
      flex-direction: column;
      > .el-input {
        width: 100% !important;
      }
      > .el-button {
        margin-top: 20px;
        width: 100% !important;
      }
    }
  }
}

@media (max-width: 700px) {
  .repairReq-step5-next {
    position: absolute;
    left: 0;
    bottom: 10px;
    border: 0 !important;
    padding-top: 0px !important;
    box-shadow: 0 -1px 8px 4px #eee;
    > .el-button {
      /* flex: 1; */
      /* border-radius: 0; */
      margin: 0 12px;
    }
  }

  .video-main {
    width: 90%;
    height: 250px;
  }

  .el-message-box {
    width: 90% !important;
  }
}
</style>
